// extracted by mini-css-extract-plugin
export default {"root":"qOv1ybEfO0","title":"zrzIeJgfvl"};